// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_fs-0";
export var actionModalContentContainer = "_fs-1";
export var createTagButton = "_fs-2";
export var footerContainer = "_fs-7";
export var fullWidthDivider = "_fs-3";
export var hasCreateTagButton = "_fs-4";
export var noCreateTagButton = "_fs-5";
export var tagsContainer = "_fs-6";
export var tagsModalContentContainer = "_fs-8";